export enum Variant {
  Transparent = 'transparent',
  NonTransparent = 'non-transparent',
}

export enum Icon {
  Pencil = 'pencil',
  Plus = 'plus',
}
